import { CalendarSetting, ID } from '@griply/types';
import { useMemo } from 'react';

import { useExternalCalendarConnections } from './use-external-calendar-connections';

export type CalendarSyncEntry = CalendarSetting & {
  connectionId: ID;
  linkedItemId: ID;
};

export const useCalendarSyncs = (): CalendarSyncEntry[] => {
  const connections = useExternalCalendarConnections();

  return useMemo(
    () =>
      connections.flatMap((connection) => {
        const calendarSettings = connection.settings?.calendarSettings;
        if (!calendarSettings) {
          return [];
        }
        return Object.entries(calendarSettings).map(
          ([linkedItemId, setting]) => ({
            ...setting,
            connectionId: connection.id,
            linkedItemId: linkedItemId as ID,
          }),
        );
      }),
    [connections],
  );
};
